import store from '@/store/'

// m (or month) is 0-indexed (0 = January, 11 = December)
const CELEBRATIONS = [
    // 🎂 Birthday (Highest Priority Override)
    {
        id: 'birthday',
        priority: 200,
        match: (m, d) => {
            const birthDateStr = store.state.birthDate; 
            if (!birthDateStr) return false;
            
            const birthDate = new Date(birthDateStr);
            if (isNaN(birthDate.getTime())) return false; 
            
            return birthDate.getMonth() === m && birthDate.getDate() === d;
        },
        greeting: "🎂 Happy Birthday",
        personalize: true
    },

    // 🎆 New Year
    {
        id: 'newyear',
        priority: 100,
        match: (m, d) => (m === 11 && d === 31) || (m === 0 && d <= 1),
        greeting: "🎆 Happy New Year",
        personalize: true
    },

    // 💖 Valentine’s Day
    {
        id: 'valentine',
        priority: 90,
        match: (m, d) => m === 1 && d === 14,
        greeting: "💖 Happy Valentine’s Day",
        personalize: true
    },

    // 🧧 Lunar New Year
    {
        id: 'lunar',
        priority: 85,
        match: (m, d) => m === 1 && d === 6,
        greeting: "🧧 Happy Lunar New Year",
        personalize: true
    },

    // 💼 Labor Day (Perfect fit for an HR/Payroll Application)
    {
        id: 'laborday',
        priority: 75,
        match: (m, d) => m === 4 && d === 1,
        greeting: "💼 Happy Labor Day",
        personalize: true
    },

    // 🎄 Christmas
    {
        id: 'christmas',
        priority: 70,
        match: (m, d) => m === 11 && d >= 24 && d <= 25,
        greeting: "🎄 Merry Christmas",
        personalize: true
    }
]

export default {
    getSeasonDetails(queryAction = null, isMobile = false) {
        const firstName = store.state.firstName
        const today = new Date()
        const month = today.getMonth()
        const day = today.getDate()
        const hour = today.getHours()

        // ---------------------------------------------------
        // 1. Query Action Messages (Highest Priority)
        // ---------------------------------------------------
        const actionMessages = {
            expired: "You've been logged out due to inactivity",
            expired_token: "You've been logged out due to inactivity",
            change_password: "Your password has been successfully changed",
            user_initiated: "You've been logged out successfully"
        }

        if (queryAction && actionMessages[queryAction]) {
            return {
                greeting: actionMessages[queryAction],
                personalize: false,
                isBirthday: false,
                className: isMobile ? "welcome-section-mobile" : "welcome-section"
            }
        }

        // ---------------------------------------------------
        // 2. Find Matching Active Celebrations
        // ---------------------------------------------------
        const matchedCelebrations = CELEBRATIONS.filter(c => c.match(month, day))

        // Sort: Highest priority wins
        matchedCelebrations.sort((a, b) => b.priority - a.priority)
        const celebration = matchedCelebrations.length > 0 ? matchedCelebrations[0] : null

        // ---------------------------------------------------
        // 3. Time Greeting Fallback Engine
        // ---------------------------------------------------
        const getTimeGreeting = () => {
            if (hour < 12) return "Good morning"
            if (hour < 18) return "Good afternoon"
            return "Good evening"
        }

        // ---------------------------------------------------
        // 4. Build Default Standard Clean State
        // ---------------------------------------------------
        const result = {
            greeting: null,
            personalize: false,
            isBirthday: false,
            className: isMobile ? "welcome-section-mobile" : "welcome-section"
        }

        // ---------------------------------------------------
        // 5. Apply Celebrations If Active
        // ---------------------------------------------------
        if (celebration) {
            result.personalize = celebration.personalize
            result.isBirthday = celebration.id === 'birthday'

            let greeting = celebration.greeting
            if (celebration.personalize && firstName) {
                greeting += ", <strong>" + firstName + "</strong>!"
            } else {
                greeting += "!"
            }

            result.greeting = greeting
            return result
        }

        // ---------------------------------------------------
        // 6. Default Time-of-Day Formatting Fallback
        // ---------------------------------------------------
        if (firstName) {
            result.greeting = getTimeGreeting() + ", <strong>" + firstName + "</strong>!"
        } else {
            result.greeting = "Welcome to <strong>SweldoNow</strong>"
        }

        return result
    }
}
